export default "__VITE_ASSET__Dq$P_WxZ__"